import { useState } from "react";
import { ChevronDown, ChevronUp } from "@unified-checkout/design-system/icons/index";
import type { INumbersCounter } from "../../types/numbers_counter";
import { Input } from "../Input";
import styles from "./numbers-counter.module.scss";

export const NumbersCounter = ({
  name,
  min = 0,
  max = 10,
  current = 3,
  step = 1,
  onChangeHandler
}: INumbersCounter) => {

  const [counter, setCounter] = useState(current);

  const handleCounterChange = (action: 'inc' | 'dec') => {
    if (
      (action === 'inc' && counter >= max)
      ||
      (action === 'dec' && counter <= min)
    ) return;

    const newCount = action === 'inc' ? counter + step : counter - step;
    
    setCounter(newCount);
    onChangeHandler?.(newCount);
  };

  return (
    <div className={styles["numbers-counter"]}>
      <Input
        name={name || "numbers-counter"}
        type="number"
        value={counter.toString() || ''}
        onChange={(e) => setCounter(parseInt(e.target.value) || 0)}
      />

      <div className={styles["numbers-counter__actions"]}>

        <div
          className={styles["numbers-counter__actions__btn"]}
          data-numbers-counter-action-btn-disabled={counter >= max}
          onClick={() => handleCounterChange('inc')}
        >
          {ChevronUp}
        </div>
        <div
          className={styles["numbers-counter__actions__btn"]}
          data-numbers-counter-action-btn-disabled={counter <= min}
          onClick={() => handleCounterChange('dec')}
        >
          {ChevronDown}
        </div>

      </div>
    </div>
  )
};
